import * as React from 'react';
import { SVGProps } from 'react';

const SvgDeleteOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 6.432h4.5v-.796c0-.439-.336-.795-.75-.795h-3c-.414 0-.75.356-.75.795v.796Zm6 0v-.796c0-1.318-1.007-2.386-2.25-2.386h-3c-1.243 0-2.25 1.068-2.25 2.386v.796h-3c-.414 0-.75.448-.75 1s.336 1 .75 1H6v10.182C6 19.932 7.007 21 8.25 21h7.5c1.243 0 2.25-1.068 2.25-2.386V8.432h.75c.414 0 .75-.448.75-1s-.336-1-.75-1h-3Zm.25 2H8v9.772c0 .44.336.796.75.796h6.5c.414 0 .75-.356.75-.796V8.432Zm-6.25 2.772v4.773c0 .44.336.796.75.796s.75-.356.75-.796v-4.773c0-.439-.336-.795-.75-.795s-.75.356-.75.795Zm3 4.773v-4.773c0-.439.336-.795.75-.795s.75.356.75.795v4.773c0 .44-.336.796-.75.796s-.75-.356-.75-.796Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDeleteOutlined;
